"use strict";

var _interopRequireDefault = require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regenerator2 = _interopRequireDefault(require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/usr/local/jpom-server/data/build/9fa77822aff1429c97ab324182a25367/source/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
// progress bar
// progress bar style
// get token from cookie

_nprogress.default.configure({
  showSpinner: false
}); // NProgress Configuration

var whiteList = ['/login', '/auth-redirect', '/banweix']; // no redirect whitelist

_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(to, from, next) {
    var hasToken, hasRoles, roles, accessRoutes, _t;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          // start progress bar
          _nprogress.default.start();

          // set page title
          document.title = (0, _getPageTitle.default)('小医配齐-业务支撑系统');

          // determine whether the user has logged in
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.n = 9;
            break;
          }
          if (!(to.path === '/login')) {
            _context.n = 1;
            break;
          }
          // if is logged in, redirect to the home page
          next({
            path: '/'
          });
          _nprogress.default.done();
          _context.n = 8;
          break;
        case 1:
          // determine whether the user has obtained his permission roles through getInfo
          hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;
          if (!hasRoles) {
            _context.n = 2;
            break;
          }
          next();
          _context.n = 8;
          break;
        case 2:
          _context.p = 2;
          _context.n = 3;
          return _store.default.dispatch('user/getInfo');
        case 3:
          roles = _context.v;
          _context.n = 4;
          return _store.default.dispatch('user/userDetail');
        case 4:
          _context.n = 5;
          return _store.default.dispatch('permission/generateRoutes', roles);
        case 5:
          accessRoutes = _context.v;
          // dynamically add accessible routes
          _router.default.addRoutes(accessRoutes);
          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history record
          next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
            replace: true
          }));
          _context.n = 8;
          break;
        case 6:
          _context.p = 6;
          _t = _context.v;
          console.log('error', _t);
          // remove token and go to login page to re-login
          _context.n = 7;
          return _store.default.dispatch('user/resetToken');
        case 7:
          _elementUi.Message.error(_t.message || 'Has Error');
          next("/login?redirect=".concat(to.path));
          _nprogress.default.done();
        case 8:
          _context.n = 10;
          break;
        case 9:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.path));
            _nprogress.default.done();
          }
        case 10:
          return _context.a(2);
      }
    }, _callee, null, [[2, 6]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  // finish progress bar
  _nprogress.default.done();
});